var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.07.024L5.241.048a2.09 2.09 0 00-1.823 1.077L.372 6.631l10.111-.024zM23.616 6.584l-3.083-5.506A2.106 2.106 0 0018.699 0L12.87.024l.612 6.583zM23.988 8.367l-11.094.036h-1.799L0 8.427v13.569a2 2 0 002.004 2l9.258-.02 10.732.02a2 2 0 002.004-2.002zM21 20.25a.75.75 0 01-.75.75h-6.5a.75.75 0 01-.75-.75v-3.5a.75.75 0 01.75-.75h6.5a.75.75 0 01.75.75z"
  })));
}

export default SvgParcel;